import type CrudAction from '@/features/crud/CrudAction';

import type { RouteRecordRaw } from 'vue-router';

import CrudActionType from '@/features/crud/CrudActionType';

const OffersPage = async () => import('@/pages/OffersPage.vue');
const OffersMassEditModal = async () => import('@/features/offers/offers-mass-edit-modal/OffersMassEditModal.vue');

export default function getOffersRoutes(): RouteRecordRaw[] {
  return [
    {
      name: 'offers',
      children: [
        {
          name: 'edit-many-offers',
          component: OffersMassEditModal,
          path: String.raw`edit/mass/:ids(\d+)+`,
          props: (route) => ({
            offerIds: route.params.ids,
          }),
        },
      ],
      component: OffersPage,
      meta: {
        title: 'Offers',
        useIn: ['navigation-tabs'],
      },
      path: '/offers',
      props: () => ({
        crudAction: null,
      }),
    },
    {
      name: 'create-offer',
      component: OffersPage,
      path: '/offers/create',
      props: (): {
        crudAction: CrudAction;
      } => ({
        crudAction: {
          type: CrudActionType.CREATE,
        },
      }),
    },
    {
      name: 'edit-offer',
      component: OffersPage,
      path: '/offers/edit/:id',
      props: (
        route,
      ): {
        crudAction: CrudAction;
      } => ({
        crudAction: {
          id: route.params.id as string,
          type: CrudActionType.EDIT,
        },
      }),
    },
    {
      name: 'clone-offer',
      component: OffersPage,
      path: '/offers/clone/:id',
      props: (
        route,
      ): {
        crudAction: CrudAction;
      } => ({
        crudAction: {
          id: route.params.id as string,
          type: CrudActionType.CLONE,
        },
      }),
    },
  ];
}
